import Vue from 'vue';
import vueDropzone from 'vue2-dropzone';
import KEYS from '../../../values/keys';
import { ED_DROPZONE_EVENTS } from '../../../content/values/events';
import Tools from '../../../providers/tools';

export default Vue.component('ed-dropzone', {
  name: 'ed-dropzone',
  components: {
    vueDropzone
  },
  props: [
    'mode', 
    'options', 
    'onUploaded', 
    'onError', 
    'onAdded', 
    'onRemoved',
    'onThumbnail',
    'dropZoneText',
    'onReset', 
    'hideText',
    'onErrorMaxFiles'
  ],
  data: () => {
    return {
      hasTimeoutError: false,
      data: null,
      isUploadingManually: false,
      descriptionProgressManually : '',
      statusProgressManually: 0
    }
  },
  computed: {
    classes() {
      return { 'ed-dropzone--multiple': this.mode ===  KEYS.DROPZONE_CONFIG.MULTIPLE };
    },
    text() {
      return this.dropZoneText ? this.dropZoneText  : this.$i18n.t('lesson.dropZoneText');
    },
    disclamerFileType() {
      return this.$i18n.t('lesson.disclamerFileType');
    },
    disclamerMaxFiles() {
      return this.$i18n.t('lesson.disclamerMaxFiles');
    },
    disclamerBigFile() {
      return this.$i18n.t('lesson.disclamerBigFile');
    },
    dropZoneRemove() {
      return this.$i18n.t('lesson.dropZoneRemove');
    },
    dropzoneOptions() {
      return {
        ...this.options, 
        dictInvalidFileType: this.disclamerFileType,
        dictMaxFilesExceeded: this.disclamerMaxFiles,
        dictFileTooBig: this.disclamerBigFile,
        dictRemoveFile: this.dropZoneRemove,
      }
    }
  },
  methods: {
    onUploadSuccess(file, res) {
      this.$emit('onUploaded', {file, res });
      this.$refs.EdDropzone.removeFile(file);
    },
    onStatusProgress(file, progress) {
      this.descriptionProgressManually = file.name;
      this.statusProgressManually = progress;
    },
    onUploadProgress(file, xhr, formData) {
      if(this.data) {
        let params = Object.keys(this.data);
        params.forEach((key) => {
          Tools.isObject(this.data[key]) ? formData.append(key, JSON.stringify(this.data[key])) : formData.append(key, this.data[key]);
        });
      }
      xhr.ontimeout = (e) => {
        this.$emit('onError', e);
        this.isUploadingManually = false;
        this.hasTimeoutError = true;
      }
      xhr.onloadend = (e) => {
        if(xhr.status == 500 || xhr.status == 404) {
          this.isUploadingManually = false;
          this.$emit('onError', e);
        }
      }
    },
    resetComponent() {
      this.hasTimeoutError = false;
      this.$refs.EdDropzone.removeAllFiles(true);
      this.$emit('onReset');
    },
    onFilesAdded(file) {
      const MAX_FILE_SIZE = this.$refs.EdDropzone.dropzone.options.maxFilesize * 1024 * 1024;
      
      if (file.size > MAX_FILE_SIZE) {
        const errorMsg = this.disclamerBigFile;
        this.$emit('onError', errorMsg);
      } else 
        if (file.size > 0) {
        this.$emit('onAdded', file)

      } else {
        this.$refs.EdDropzone.removeFile(file);
        let errorMessage = {
          message:{
            status:400,
            errors:[{
              status:'DROPZONE001',
              attributes:{}
            }]
          }
        };
        this.$emit('onError', errorMessage);
      }
      
    },
    async processQueue(data): Promise<void> {
      return new Promise((resolve,reject) => {
        try{
          this.data = data;
          this.isUploadingManually = true;
          this.statusProgressManually = 0;
          if(this.$refs.EdDropzone) {
            this.$refs.EdDropzone.processQueue();
            resolve();
          }
          else{
            resolve();
          }
        }
        catch{
          reject();
        }
      })
    },
    enqueueFile(data) {
      if(data.url) this.$refs.EdDropzone.setOption('url' , data.url);      
      this.$refs.EdDropzone.dropzone.enqueueFile(data.file);
    },
    onFileRemoved(file) {
      this.$emit('onRemoved', file);
    },
    removeFile(file){
      this.$refs.EdDropzone.removeFile(file);
    },
    removeAllFiles() {
      this.$refs.EdDropzone.removeAllFiles();
    },
    onThumbnailAdded(file, dataUrl) {
      this.$emit('onThumbnail', { file, dataUrl });
    },
    addFile(file) {
      this.$refs.EdDropzone.manuallyAddFile(file, '');
    },
    onFileError(file , message) {
      this.$emit('onError', {file , message});
      // this.$refs.EdDropzone.removeAllFiles(true);
      this.isUploadingManually = false;
      this.descriptionProgressManually = '';
      this.statusProgressManually = 0;
    },
    onMaxFilesError(file) {
      this.$emit('onErrorMaxFiles', {file});
    }
  },
  created() {
    this.$edEventBus.$on(ED_DROPZONE_EVENTS.UPLOAD_FILE, this.processQueue);
  },
  beforeUpdate() {
    const dropOptions = this.$refs.EdDropzone.dropzone.options;
    dropOptions.dictInvalidFileType = this.disclamerFileType;
    dropOptions.dictMaxFilesExceeded = this.disclamerMaxFiles;
    dropOptions.dictFileTooBig = this.disclamerBigFile;
    dropOptions.dictRemoveFile = this.dropZoneRemove;
  },
  updated() {
    if (this.$refs.EdDropzone.dropzone.files?.length > 0) {
      this.$refs.EdDropzone.dropzone.files.forEach(file => {
        if (file.status === 'error') {
          this.resetComponent();
          return;
        }
      });
    }
  },
});
